import type { FC } from 'react';
import { Button } from '@mui/material';
import { Iconify } from '@pflegenavi/web-components';

interface DownloadPdfButtonViewProps {
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  label: string;
}

export const DownloadPdfButtonView: FC<DownloadPdfButtonViewProps> = ({
  onClick,
  disabled = false,
  loading = false,
  label,
}) => {
  return (
    <Button
      onClick={onClick}
      variant="text"
      disabled={disabled || loading}
      startIcon={<Iconify icon="ph:download-simple-bold" width={20} />}
    >
      {label}
    </Button>
  );
};
